/** Move to the first visible missing price in desktop or responsive forms. */
export function focusMissingPrice(form: HTMLElement | null) {
  const field = Array.from(form?.querySelectorAll<HTMLInputElement>('[aria-invalid="true"]') || [])
    .find(input => !input.disabled && input.getClientRects().length > 0);
  field?.scrollIntoView?.({ behavior: "smooth", block: "center" });
  field?.focus({ preventScroll: true });
}
